// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconAlphaC = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M12.086 15.698c1.302 0 2.142-.728 2.604-1.638l1.75.294c-.616 1.582-2.058 2.842-4.424 2.842-2.996 0-4.942-2.212-4.942-5.208s1.946-5.236 4.97-5.236c2.198 0 3.724 1.106 4.34 2.8l-1.778.35c-.476-1.022-1.372-1.652-2.59-1.652-1.988 0-3.122 1.638-3.122 3.738 0 2.114 1.19 3.71 3.192 3.71" />,
    <path
      fillRule="evenodd"
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 1116 0 8 8 0 01-16 0"
    />
  );
export default SvgIconAlphaC;
